const translations = {
  "en": {
    "Verify": "Verify"
  },
  "zh-tw": {
    "Verify": "驗證"
  }
};

export default translations;
